var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeHassleOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 47.069 55.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15922",
    "data-name": "Group 15922",
    transform: "translate(-39.892 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28295",
    "data-name": "Path 28295",
    d: "M268.624,4.674a1.068,1.068,0,0,0,1.068-1.068V1.068a1.068,1.068,0,1,0-2.137,0V3.606A1.068,1.068,0,0,0,268.624,4.674Z",
    transform: "translate(-202.895)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28296",
    "data-name": "Path 28296",
    d: "M86.461,116.118a4.354,4.354,0,0,0-1.506-3.295,4.361,4.361,0,0,0-2.857-7.658H69.123l1.5-5.653c1.237-4.665-.944-9.024-3.674-10.387-1.6-.8-2.888-.928-3.932-.39-1.426.734-1.876,2.445-2.15,4.183-1.04,6.569-2.6,11.007-7.422,14.661a2.969,2.969,0,0,0-2.864-2.2H43.356a2.968,2.968,0,0,0-2.964,2.964v21.5a2.968,2.968,0,0,0,2.964,2.964h7.223a2.969,2.969,0,0,0,2.87-2.221,26.358,26.358,0,0,0,11.239,3.084h14.9a4.361,4.361,0,0,0,3.656-6.743,4.364,4.364,0,0,0,1.709-7.508A4.355,4.355,0,0,0,86.461,116.118ZM51.406,129.837a.838.838,0,0,1-.827.827H43.356a.838.838,0,0,1-.827-.827v-21.5a.838.838,0,0,1,.827-.827h7.223a.838.838,0,0,1,.827.827v21.5Zm26.2-15.945H82.1a2.226,2.226,0,1,1,0,4.453H77.607a1.068,1.068,0,0,0,0,2.137H82.1a2.228,2.228,0,0,1,0,4.456H77.607a1.068,1.068,0,1,0,0,2.137H79.59a2.227,2.227,0,0,1,0,4.453h-14.9c-3.072,0-8.526-1.5-11.145-3.42V110.127a18.973,18.973,0,0,0,6.506-6.945,30.537,30.537,0,0,0,2.926-9.931c.1-.623.359-2.277,1.017-2.616.379-.2,1.089-.053,2,.4,1.727.863,3.579,4.1,2.564,7.928l-1.853,7a1.08,1.08,0,0,0,1.033,1.342H82.1a2.226,2.226,0,1,1,0,4.453H77.607a1.068,1.068,0,1,0,0,2.137Z",
    transform: "translate(0 -78.964)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28297",
    "data-name": "Path 28297",
    d: "M95.346,302.706a1.07,1.07,0,1,0,1.068,1.071v-.006A1.066,1.066,0,0,0,95.346,302.706Z",
    transform: "translate(-48.129 -270.366)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28298",
    "data-name": "Path 28298",
    d: "M159.549,33.7l1.9,1.684a1.068,1.068,0,0,0,1.418-1.6l-1.9-1.684a1.068,1.068,0,0,0-1.418,1.6Z",
    transform: "translate(-106.106 -28.431)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28299",
    "data-name": "Path 28299",
    d: "M359.219,35.653a1.065,1.065,0,0,0,.708-.269l1.9-1.684a1.068,1.068,0,1,0-1.418-1.6l-1.9,1.684a1.068,1.068,0,0,0,.709,1.868Z",
    transform: "translate(-283.811 -28.432)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28300",
    "data-name": "Path 28300",
    d: "M121.833,120.479l2.538.106h.045a1.068,1.068,0,0,0,.044-2.136l-2.538-.106a1.068,1.068,0,0,0-.089,2.135Z",
    transform: "translate(-71.826 -105.7)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28301",
    "data-name": "Path 28301",
    d: "M390.55,119.564a1.068,1.068,0,0,0,1.067,1.024h.045l2.538-.106a1.068,1.068,0,0,0-.089-2.135l-2.538.106A1.068,1.068,0,0,0,390.55,119.564Z",
    transform: "translate(-312.748 -105.701)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeHassleOut);
export default __webpack_public_path__ + "static/media/TakeHassleOut.797fc764dae206ed53894cd5b7420a95.svg";
export { ForwardRef as ReactComponent };